/**
 * We want to release Memory Retention Settings only to selected workspaces (just one, actually).
 * The BE does not support feature flags per-workspace,
 * so we are hardcoding allowed ones here as a workaround.
 */
export const MEMORY_RETENTION_ENABLED_WORKSPACE_IDS = [958471];
